import React, { useState, useEffect } from "react";
import {
  TextField,
  Container,
  Button,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { Helmet } from "react-helmet";
import AccountCircle from "@mui/icons-material/AccountCircle";
import InputAdornment from "@mui/material/InputAdornment";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useAuthUser } from "../store/AuthUserContextProvider";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router";
import { RotateSpinner } from "react-spinners-kit";
import { useHistory } from "react-router-dom";
import { setAuthenticatedUser } from "../store/action-reducers";
import { authenticateUser } from "./../api/api";
import RIS_BACKGROUND_IMAGE from "../img/DR-photo.png";
import { isAuthenticated } from "../utils";

const Signin = (props) => {
  const history = useHistory();
  const { authUserDispatch } = useAuthUser();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [signCredentials, setSigninCredentials] = useState({
    username: "",
    password: "",
  });

  useEffect(() => {
    if (isAuthenticated()) history.push("/");
  }, []);

  const handleFieldChange = (event) => {
    setSigninCredentials({
      ...signCredentials,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (!signCredentials.username || !signCredentials.password)
        throw { message: "Please fill in all required fields." };

      const [response, error] = await authenticateUser(
        signCredentials.username,
        signCredentials.password
      );

      if (error) throw { message: "Error authenticating: " + error.message };

      switch (response.status) {
        case 200:
          setLoading(false);

          const user = {
            ...JSON.parse(response.data),
            tempus: new Date().getTime(),
          };

          delete user.Password;

          const hominem = btoa(JSON.stringify(user));
          localStorage.setItem("hominem", hominem);
          authUserDispatch(setAuthenticatedUser(user));
          history.push("/scheduler");
          break;
        case 204:
          throw { message: response.message };
      }
    } catch (err) {
      props.enqueueSnackbar(err.message, {
        preventDuplicate: true,
        variant: "warning",
      });
      console.log(err.message);
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>

      <Box
        sx={{
          backgroundImage: `url(${RIS_BACKGROUND_IMAGE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          order:1
        }}
      >
        <Container
          sx={{
            height: "100vh",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            background: "rgb(0,0,0)",
            position: "relative",
          }}
          component="main"
          maxWidth="xs"
        >
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              name="username"
              helperText="Username/Email*"
              value={signCredentials.username}
              onChange={handleFieldChange}
              sx={{ mb: 2, borderRadius: "0 !important" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              fullWidth
              name="password"
              helperText="Password*"
              type={showPassword ? "text" : "password"}
              value={signCredentials.password}
              onChange={handleFieldChange}
              sx={{ borderRadius: "0 !important" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOpenIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      onMouseDown={(event) => event.preventDefault()}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 3, mb: 2, gap: 2 }}
              type="submit"
              onClick={handleSubmit}
            >
              {loading ? (
                <>
                  <RotateSpinner size={20} color="#fff" />
                  Signing in
                </>
              ) : (
                <>Sign In</>
              )}
            </Button>
          </form>

          <Typography
            variant="small"
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(10,10,10)",
              textAlign: "center",
              fontSize: "10px",
              p: 1,
              color: "#999",
              borderTop: "1px #f44336 solid",
            }}
          >
            @ {new Date().getFullYear()} OneRad
          </Typography>
        </Container>

        <Box
          sx={{
            flex: 1,
            height: "100%",
            width: "100%",
          }}
        />
      </Box>
    </>
  );
};

export default withRouter(withSnackbar(Signin));
